<template>
    <section class="cabinet-content-wrap cabinet-content-wrap--cart-public">
        <template v-if="successfulDispatchOfGoods">
            <header
                class="cabinet-header flex flex-align-center justify-content-between"
            >
                <h1 class="h1 v2-retailer-title">Ваш заказ отправлен!</h1>
            </header>

            <div class="v2-retailer-cart__placed">
                <div class="mb-3">
                    Мы отправили каждому поставщику письмо с изделиями, которые
                    вы хотите заказать. Также мы указали в письме ваши
                    контактные данные, ч тобы поставщик мог с вами связаться.
                </div>
            </div>
        </template>

        <template v-else>
            <div v-if="!cart.length">
                <header
                    class="cabinet-header flex flex-align-center justify-content-between"
                >
                    <h1 class="h1 v2-retailer-title">Корзина пуста</h1>
                </header>

                <div class="v2-retailer-cart__top">
                    <div class="v2-retailer-cart__top-total">
                        Здесь пока ничего нет
                    </div>
                    <router-link
                        :to="`${routeBack}`"
                        class="v2-retailer-cart__top-link"
                        >Продолжить покупки</router-link
                    >
                </div>
            </div>

            <div v-else>
                <header
                    class="cabinet-header flex flex-align-center justify-content-between"
                >
                    <h1 class="h1 v2-retailer-title">Заказ</h1>
                    <button
                        type="button"
                        class="cabinet-btn-icon cabinet-btn-icon--small cabinet-btn-icon--trash-grey d-md-none js-modal-toogle"
                        data-target="js-modal-remove-all"
                        @click="openModal('ClearCart')"
                    ></button>
                </header>

                <div class="v2-retailer-cart__top">
                    <div class="v2-retailer-cart__top-total">
                        {{ totalAmount }}
                        {{
                            getNounByNum(totalAmount, [
                                'Изделие',
                                'Изделия',
                                'Изделий'
                            ])
                        }}
                        от {{ itemsBrand.length }}
                        {{
                            getNounByNum(itemsBrand.length, [
                                'Бренда',
                                'Брендов'
                            ])
                        }}
                    </div>
                    <div
                        class="v2-retailer-cart__top-delete js-modal-toogle"
                        data-target="js-modal-remove-all"
                        @click="openModal('ClearCart')"
                    >
                        Удалить все
                    </div>
                </div>

                <section
                    class="v2-retailer-cart__content v2-retailer-cart__content--public"
                >
                    <div class="v2-retailer-cart__content-left">
                        <div
                            v-for="(itemBrand, index) in itemsBrand"
                            :key="index"
                            class="v2-retailer-cart__brand js-brand-1"
                        >
                            <div class="v2-retailer-cart__brand-title">
                                {{ itemBrand[0].brand.BrandName }}
                            </div>

                            <BrandProduct
                                v-for="item in itemBrand"
                                :key="item.ItemID"
                                :item="item"
                                @deleteItem="deleteItem"
                                @lessQty="lessQty"
                                @moreQty="moreQty"
                                @setComment="setComment"
                            />
                        </div>
                    </div>
                    <div class="v2-retailer-cart__content-right">
                        <div
                            class="v2-retailer-cart__customer v2-retailer-cart__customer--public js-customer"
                        >
                            <div class="v2-retailer-cart__customer-title">
                                Данные покупателя
                            </div>
                            <form>
                                <div class="cabinet-form-group">
                                    <label
                                        class="cabinet-form-group__label required"
                                        for="name"
                                        >Имя</label
                                    >
                                    <input
                                        id="name"
                                        v-model.trim="$v.name.$model"
                                        type="text"
                                        class="cabinet-form-group__input"
                                        :class="{ error: $v.name.$error }"
                                    />
                                    <p
                                        v-if="
                                            !$v.name.required && $v.name.$dirty
                                        "
                                        class="cabinet-form-group__note"
                                    >
                                        Поле обязательно для заполения
                                    </p>
                                </div>

                                <div class="cabinet-form-group">
                                    <span class="phone">+7</span>
                                    <label
                                        class="cabinet-form-group__label required"
                                        for="phone"
                                        >Номер телефона</label
                                    >
                                    <the-mask
                                        id="phone"
                                        v-model.trim="$v.phone.$model"
                                        :mask="'###-###-##-##'"
                                        type="text"
                                        class="cabinet-form-group__input cabinet-form-group__input--phone"
                                        :class="{ error: $v.phone.$error }"
                                    />
                                    <p
                                        v-if="
                                            !$v.phone.required &&
                                                $v.phone.$dirty
                                        "
                                        class="cabinet-form-group__note"
                                    >
                                        Поле обязательно для заполения
                                    </p>
                                    <p
                                        v-if="
                                            !$v.phone.minLength &&
                                                $v.phone.$dirty
                                        "
                                        class="cabinet-form-group__note"
                                    >
                                        Введите полный номер телефона
                                    </p>
                                </div>

                                <div class="cabinet-form-group">
                                    <label
                                        class="cabinet-form-group__label required"
                                        for="email"
                                        >Электронная почта</label
                                    >
                                    <input
                                        id="email"
                                        v-model.trim="$v.email.$model"
                                        type="text"
                                        class="cabinet-form-group__input"
                                        :class="{ error: $v.email.$error }"
                                    />
                                    <p
                                        v-if="
                                            !$v.email.required &&
                                                $v.email.$dirty
                                        "
                                        class="cabinet-form-group__note"
                                    >
                                        Поле обязательно для заполения
                                    </p>
                                    <p
                                        v-if="
                                            !$v.email.email && $v.email.$dirty
                                        "
                                        class="cabinet-form-group__note"
                                    >
                                        Некоректный адресс электронной почты
                                    </p>
                                </div>

                                <!-- <div class="cabinet-form-group">
                            <label class="cabinet-form-group__label">Юридическое лицо</label>
                            [название юр лица]
                            </div>-->
                            </form>
                        </div>
                        <div
                            class="v2-retailer-cart__total js-sticky-total"
                            data-margin-top="32px"
                        >
                            <div class="v2-retailer-cart__total-all">
                                <p>Изделий в заказе</p>
                                <p>{{ totalAmount }}</p>
                            </div>
                            <div class="v2-retailer-cart__total-title">
                                Итого
                                <span
                                    >~
                                    {{
                                        isInteger(+totalCost)
                                            ? (+totalCost).toFixed()
                                            : (+totalCost).toFixed(2)
                                    }}
                                    ₽</span
                                >
                            </div>
                            <div class="v2-retailer-cart__info">
                                Сумма заказа является примерной. Точную сумму
                                уточняйте у поставщика.
                            </div>
                            <button
                                type="button"
                                class="cabinet-btn cabinet-btn--big cabinet-btn--input-w"
                                :class="{ loading: loading.sendDataCart }"
                                @click="submit"
                            >
                                Отправить заказ
                            </button>
                            <div class="v2-retailer-cart__info mt-4">
                                <strong>
                                    Нажимая “Отправить заказ” я даю согласие на
                                    обработку персональных данных в соответствии
                                    с
                                    <a
                                        href="https://docs.goldnet.market/doku.php?id=privacy_policy"
                                        target="_blank"
                                        >Политикой конфиденциальности</a
                                    >
                                    и принимаю
                                    <a
                                        href="https://docs.goldnet.market/doku.php?id=user_agreement"
                                        target="_blank"
                                        >Пользовательское соглашение</a
                                    >.
                                </strong>
                            </div>
                            <div class="v2-retailer-cart__note mt-4">
                                Всем поставщикам будут отправлены письма с
                                вашими заказами. Дальнейшая работа по заказам
                                будет происходить напрямую с поставщиком, без
                                участия площадки.
                            </div>
                        </div>
                    </div>
                </section>

                <div class="app-overlay hide js-overlay"></div>

                <div id="js-modal-confirm" class="app-modal hide js-modal">
                    <div class="app-modal__close js-modal-close"></div>
                    <div class="app-modal__header flex">
                        <div class="subtitle1 app-modal__title">
                            Запрос доступа
                        </div>
                    </div>
                    <div class="app-modal__body">
                        Запросив доступ к скрытым изделиям, вы получите
                        возможность просматривать расширенный каталог изделий
                        бренда.
                        <br />
                        <br />Поставщик бренда
                        <strong>“Альтаир”</strong> получит уведомление о вашем
                        запросе и рассмотрит его.
                    </div>
                    <div
                        class="app-modal__footer flex flex-justify-end flex-wrap"
                    >
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--default order-2 order-md-1 js-modal-close"
                        >
                            Отменить
                        </button>
                        <button
                            type="button"
                            class="cabinet-btn js-modal-close app-modal__btn order-1 order-md-2"
                        >
                            Отправить запрос
                        </button>
                    </div>
                </div>

                <clear-cart-modal
                    :is-open="isClearCartModalOpened"
                    @onConfirm="onConfirmClearCart"
                    @onClose="closeModal('ClearCart')"
                />
            </div>
        </template>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { TheMask } from 'vue-the-mask'

import modal from '@/mixins/modal'
import BrandProduct from '@/components/Public/Cart/BrandProduct'
import getNounByNum from '@/utils/getNounByNum'
import ClearCartModal from '@/components/Cabinet/Cart/ClearCartModal'

export default {
    name: 'PublicCart',

    components: {
        BrandProduct,
        TheMask,
        ClearCartModal
    },

    mixins: [modal],

    data() {
        return {
            name: '',
            email: '',
            phone: '',
            routeBack: '/',
            successfulDispatchOfGoods: false,
            isClearCartModalOpened: false
        }
    },

    created() {
        this.setCartPublicFromLocStor()
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            const Vm = vm

            if (from.name) {
                Vm.routeBack = from.fullPath
            }
        })
    },

    computed: {
        ...mapGetters({
            cart: 'publicCart',
            totalCost: 'totalCostCartPublic',
            totalAmount: 'totalAmountCartPublic',
            loading: 'loadingCartPublic'
        }),
        itemsBrand() {
            const brandId = Array.from(
                new Set(this.cart.map(item => item.BrandID))
            )

            return brandId.map(item =>
                this.cart.filter(el => el.BrandID === item)
            )
        }
    },

    methods: {
        ...mapActions([
            'quantityLessItemCartPublic',
            'quantityMoreItemCartPublic',
            'deleteItemCartPublic',
            'deleteAllCartPublic',
            'setCartPublicFromLocStor',
            'setCommentItemCartPublic',
            'sendDataCartPublic'
        ]),
        deleteItem(id) {
            this.deleteItemCartPublic(id)

            this.$notify({
                type: 'default',
                title: 'Изделие удалено из корзины'
            })
        },
        lessQty(id) {
            this.quantityLessItemCartPublic(id)
        },
        moreQty(id) {
            this.quantityMoreItemCartPublic(id)
        },
        setComment({ item, comment }) {
            this.setCommentItemCartPublic({ item, comment })
        },
        onConfirmClearCart() {
            this.deleteAllCartPublic()
        },
        submit() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            } else {
                const dataCart = {
                    Contacts: {
                        Name: this.name,
                        Phone: '+7' + this.phone,
                        Email: this.email
                    },
                    Cart: this.cart.map(el => {
                        const { qty, comment, ItemID } = el

                        const id = ItemID
                        const Quantity = qty
                        const Comment = comment

                        return Comment
                            ? { id, Quantity, Comment }
                            : { id, Quantity }
                    })
                }

                this.sendDataCartPublic(dataCart)
                    .then(() => {
                        this.successfulDispatchOfGoods = true

                        this.deleteAllCartPublic()
                    })
                    .catch(error => {
                        this.$notify({
                            title: error.response.data.error,
                            type: 'error'
                        })
                    })
            }
        },
        isInteger(num) {
            return (num ^ 0) === num
        },
        getNounByNum
    },

    validations: {
        name: {
            required
        },
        email: {
            required,
            email
        },
        phone: {
            required,
            minLength: minLength(10)
        }
    }
}
</script>
